import React, { useEffect, useRef, useState } from "react";
import { Breadcrumb, Form, Select, Spin, Space, Table, Col, Row, Tooltip, Button } from "antd";
import { Trans, useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ReactComponent as ZipCode } from "../../image/ZipCode.svg";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import { DeleteOutlined } from "@ant-design/icons";
import { getRequest, patchRequest, postRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import InputField from "../../common/htmlComponents/InputField";
import ButtonField from "../../common/htmlComponents/ButtonField";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import "antd/dist/antd.css";
import "../../styles/Main.scss";

const AddHierarchy = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { Option } = Select;
  const { id } = useParams();
  const AddressId = id ? atob(id) : null;
  const formRef = useRef();
  const initialState = {
    user: authUserData()?.user_id,
    state: "",
    city: "",
    address_line_1: "",
    address_line_2: "",
    landmark: "",
    pincode: "",
    address_type: "",
    email: "",
    phone: "",
  };
  const [state, setState] = useState(initialState);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);
  const [employeeName, setEmployeeName] = useState([]);
  // const [zoneList, setZoneList] = useState([]);
  // const [loading, setLoading] = useState(false);
  // const [selectedRow, setSelectedRow] = useState([]);
  // const [totalCount, settotalCount] = useState(0);
  const rowSelection = {
    onChange: (selectedRowKeys) => {
      //setSelectedRow(selectedRowKeys);
    },
  };
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "user_name" && sortOrder === "ascend") {
      sortingEnumKey = "user_name";
    }
    if (sortField === "user_name" && sortOrder === "descend") {
      sortingEnumKey = "-user_name";
    }
    if (sortField === "designation" && sortOrder === "ascend") {
      sortingEnumKey = "designation";
    }
    if (sortField === "designation" && sortOrder === "descend") {
      sortingEnumKey = "-designation";
    }
    if (sortField === "email" && sortOrder === "ascend") {
      sortingEnumKey = "email";
    }
    if (sortField === "email" && sortOrder === "descend") {
      sortingEnumKey = "-email";
    }
    if (sortField === "phone" && sortOrder === "ascend") {
      sortingEnumKey = "phone";
    }
    if (sortField === "phone" && sortOrder === "descend") {
      sortingEnumKey = "-phone";
    }
    if (sortField === "sequence" && sortOrder === "ascend") {
      sortingEnumKey = "sequence";
    }
    if (sortField === "sequence" && sortOrder === "descend") {
      sortingEnumKey = "-sequence";
    }
    return sortingEnumKey;
  };
  const columns = [
    {
      title: "User Name",
      dataIndex: "user_name",
      key: "user_name",
      sorter: true,
    },
    {
      title: "Designation",
      dataIndex: "designation",
      key: "designation",
      sorter: true,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: true,
    },
    {
      title: "Phone or Whatsapp Number",
      dataIndex: "phone",
      key: "phone",
      sorter: true,
    },
    {
      title: "Sequence",
      dataIndex: "sequence",
      key: "sequence",
      sorter: true,
    },
    {
      title: "ACTION",
      key: "operation",
      fixed: "right",
      width: "100px",
      render: (text, record) => (
        <Space>
          <Link
            to={{
              pathname: "/delivery-address/edit/" + btoa(record.id),
            }}
          >
            {authUserData()?.permission.includes(
              "common|change_approvalhierarchy"
            ) &&
              <Editicon />
            }
            {authUserData()?.permission.includes(
              "common|delete_approvalhierarchy"
            ) &&
              <DeleteOutlined />
            }
          </Link>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    const addressGetById = async () => {
      try {
        setapiLoading(true);
        const apiResponse = await getRequest(`delivery-address/${AddressId}/`);
        if (apiResponse.data.success) {
          setState(apiResponse.data.data);
          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
            phone: String(apiResponse.data.data.phone),
          });
          setapiLoading(false);
        } else {
          ErrorNotificationMsg(t("error_in_list_delivery_address"));
        }
      } catch (error) {
        setapiLoading(false);
      }
    };
    if (AddressId !== null) {
      addressGetById();
    }
    getPincode();
  }, [AddressId, t]);

  const getPincode = async (data) => {
    await getRequest("employee/", data).then((response) => {
      setEmployeeName(response.data.results.data);
    });
  };

  const handleSelectChange = (name, value) => {
    setState({ ...state, [name]: value });
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      const payload = {
        user: state.user,
        state: state.state,
        city: state.city,
        address_line_1: state.address_line_1,
        address_line_2: state.address_line_2,
        landmark: state.landmark,
        pincode: state.pincode,
        address_type: state.address_type,
        email: state.email,
        phone: state.phone,
      };
      let apiResponse;
      if (AddressId === null) {
        apiResponse = await postRequest("delivery-address/", payload);
      } else {
        apiResponse = await patchRequest(
          `delivery-address/${AddressId}/`,
          payload
        );
      }
      if (apiResponse.data.success) {
        SuccessNotificationMsg(
          AddressId === null
            ? t("delivery_address_added_successfully")
            : t("delivery_address_updated_successfully")
        );
        setState(initialState);
        formRef.current.setFieldsValue(initialState);
        setBtnLoading(false);
        navigate("/delivery-address");
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Access detailed descriptions of each role within the procurement hierarchy,
                  including responsibilities and authority levels.
                </span>
              }
            >
              <h3>{t("pl_hierarchy")}</h3>
            </Tooltip>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("pl_hierarchy")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>

        </div>
      </div>

      <section className="grid-sec FormSection Container">

        <div className="FormBody">
          <Spin spinning={apiLoading}>
            <Form onFinish={handleSubmit} autoComplete="off" ref={formRef}>
              <Row gutter={[15]}>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <InputField
                    name="hierarchy"
                    className="cust-input"
                    handleInputChange={handleInputChange}
                    rules={t("val_please_enter_address")}
                    label={t("label_hierarchy")}
                    placeholder={t("pl_rfq_approval")}
                  />
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <InputField
                    name="applicable_on"
                    className="cust-input"
                    handleInputChange={handleInputChange}
                    rules={t("val_address1")}
                    label={t("pl_applicable_on")}
                    placeholder={t("pl_rfq")}
                  />
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="employee"
                    className="cust-input"
                    label={t("pl_select_employee")}
                    prefix={<ZipCode />}
                    rules={[
                      {
                        required: true,
                        message: <Trans>{t("val_select_employee")}</Trans>,
                      },
                    ]}
                  >
                    <Select
                      showArrow
                      placeholder={t("pl_select_employee")}
                      onChange={(value) =>
                        handleSelectChange("employee", value)
                      }
                      optionFilterProp="children"
                    >
                      {employeeName.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.employe_id}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={6}
                  xl={6}
                  className="TextFeild gutter-row"
                >
                  <InputField
                    name="sequence"
                    className="cust-input"
                    handleInputChange={handleInputChange}
                    rules={t("val_sequence")}
                    label={t("pl_sequence")}
                    placeholder="1"
                  />
                </Col>
              </Row>

              <div className="FormFooter">
                <Tooltip
                  color={colors}
                  placement="right"
                  title={
                    <span style={{ color: "#fff" }}>
                      Assign responsibilities, view reporting relationships, and streamline workflow management.
                    </span>
                  }
                >
                  {authUserData()?.permission.includes(
                    "common|add_approvalhierarchy"
                  ) &&

                    <ButtonField
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="Submit"
                      label={t("add")}
                      loading={btnLoading}
                    />

                  }
                </Tooltip>
              </div>

            </Form>

            <Table
              scroll={{
                x: 2000,
              }}
              rowSelection={rowSelection}
              columns={columns}
              rowKey={(record) => record.id}
              // dataSource={zoneList}
              // loading={loading}
              pagination={{
                defaultCurrent: state.page,
                defaultPageSize: state.pagesize,
                //total: totalCount,
                //showTotal: (total) => `Total ${total} items`,
                showSizeChanger: true,
              }}
              onChange={handleTableChange}
            />

          </Spin>
        </div>
      </section>
    </>
  );
};

export default AddHierarchy;
